import {useCallback} from "react";
import {getSubmit, postSubmit} from "@ui-seeker/utils";

import {BACKEND_APIS} from "@constants";
import {isLoadMoreItems, rawMatcherItems} from "../@signals";


export default function useRawMatcherItems() {

	const handleSubmit = useCallback((queryParams = null) => {
		isLoadMoreItems.value = true
		const params = {}
		if (queryParams) {
			if (typeof queryParams === 'object') {
				Object.assign(params, queryParams)
			} else {
				// Backward compat: bare id_mapping value
				params.id_mapping = queryParams
			}
		}
		getSubmit(`${BACKEND_APIS.MATCHERS}/raw/load-items`, params).then(({ items }) => {
			rawMatcherItems.value = [...(rawMatcherItems.value || []), ...items]
			isLoadMoreItems.value = false
		}).catch(() => isLoadMoreItems.value = false)
	}, [])

	const handleMoreProducts = useCallback(() => {
		rawMatcherItems.value = null
		postSubmit(`${BACKEND_APIS.MATCHERS}/skus/disabled-filters`).then(() => {
			handleSubmit()
		}).catch(() => rawMatcherItems.value = [])
	}, [])


	return {
		handleSubmit,
		handleMoreProducts
	}
}